import { startOfDay } from "date-fns"

export const shouldRouteExpiredPlanUsers = (user) => {
  const productId = user?.planInfo?.product?.id;
  const coverEndDate = startOfDay(new Date(user?.planInfo?.cover_end_date));
  const currentDate = startOfDay(new Date());

  const userAccessProductExceptions =
    process.env?.REACT_APP_ALLOW_THESE_PRODUCT_ID_TO_LOGIN_WHEN_EXPIRED?.split(",")?.map(
      (item) => +item
    ) || [];

  const productExistInExceptions =
    userAccessProductExceptions.includes(productId);

  /*Suspended = 4, Expired = 5, Delayed = 7*/
  const invalidStatuses = [4, 5, 7];

  const isAnInvalidStatus = invalidStatuses.includes(
    user?.planInfo?.active_status_id
  );

  if (productExistInExceptions) {
    const planHasExpired = coverEndDate <= currentDate;

    return isAnInvalidStatus && planHasExpired;
  }

  return isAnInvalidStatus;
};
